// @ts-nocheck
export default {
  ICON: 'icon',
  ICON_TYPE: 'wysiwyg.viewer.components.PopupCloseIconButton',
  TEXT: 'text',
  TEXT_TYPE: 'wysiwyg.viewer.components.PopupCloseTextButton',
};
